import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import PaymentSuccessArtwork from "../assets/images/payment-success-artwork.png";

const PaymentSuccess = () => {

    const navigate = useNavigate();
    const [redirectCounter, setRedirectingCounter] = useState(5)

    useEffect(() => {
        const interval = setInterval(() => {
            setRedirectingCounter((prevCount) => {
            if (prevCount > 0) {
              return prevCount - 1;
            } else {
              clearInterval(interval)
              return prevCount;
            }
          });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (redirectCounter < 1) {
            navigate('/')
        }
    }, [redirectCounter])

    return (
        <div className="w-screen h-screen p-12 bg-[#13181E] flex flex-row items-center justify-center gap-8">
            <div className="w-[90%] md:w-[37%] p-4 md:p-8 bg-[#192738] rounded-md flex flex-col justify-center items-center">
                <div className="w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[24px] md:text-[32px] font-inter font-medium leading-[120%] text-center">
                    {`You've just unlocked Muzify Pro!`}
                </div>
                <div className="mt-2 w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[14px] md:text-[20px] font-inter leading-[120%] text-center">
                    {`No quiz limit for rest of the month! Go on, conquer every category you can imagine!`}
                </div>
                <div className="mt-12 w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[10px] md:text-[16px] font-inter leading-[120%] text-center opacity-70">
                    {`We're loading your next jam session. Stay tuned, and we'll have you playing in no time!`}
                </div>
                <div className="mt-1 w-[90%] md:w-[80%] flex justify-center items-center text-[#FEC330] text-[10px] md:text-[16px] font-inter leading-[120%] text-center opacity-70">
                    {`Redirecting in ${redirectCounter} seconds...`}
                </div>
            </div>
            <div className="w-[43.75%] hidden md:flex justify-center items-center">
                <img src={PaymentSuccessArtwork} alt="payment success artwork" className="w-full h-auto" />
            </div>
        </div>
    )
}

export default PaymentSuccess
